// src/components/Admin/StudentHomeCmp/StudenthomePortalCmp/RutsPanelStudent.js
import React, { useState, useEffect, useCallback } from "react";
import { Card, Loader, Message, Button, Image } from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
import noAvatar from "../../../../assets/png/icoeduca360.png";
import { useTranslation } from "react-i18next";
import "./RutsPanelStudent.scss";

const didacticRoutesAPI = new DidacticRoutesAPI();

export function RutsPanelStudent({
  accessToken,
  institutionId,
  classNumber,
  onSelectRoute,
}) {
  const { t } = useTranslation("students");
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRoutes = useCallback(async () => {
    if (!institutionId || !classNumber) return;

    try {
      setLoading(true);
      setError(null);

      const result = await didacticRoutesAPI.getRutasDidacticasByClassNumber(
        accessToken,
        institutionId,
        classNumber,
      );

      // Filtrar sólo rutas con escena activa
      const filteredRoutes = (result.rutas || []).filter((route) => {
        const hasScene = route.sceneactive && route.sceneactive.trim() !== "";
        const hasSceneId = !!route.sceneactive_Id;
        return hasScene && hasSceneId;
      });

      setRoutes(filteredRoutes);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [accessToken, classNumber, institutionId]);

  useEffect(() => {
    fetchRoutes();
  }, [fetchRoutes]);

  if (loading)
    return (
      <Loader active inline="centered">
        {t("portal.loadingRoutes")}
      </Loader>
    );
  if (error)
    return (
      <Message negative>
        <Message.Header>{t("portal.errorOccurred")}</Message.Header>
        <p>{error}</p>
      </Message>
    );
  if (routes.length === 0)
    return (
      <Message info>
        <Message.Header>{t("portal.noRoutes")}</Message.Header>
        <p>{t("portal.noRoutesContent")}</p>
      </Message>
    );

  return (
    <Card.Group itemsPerRow={4} stackable className="ruts-panel-student">
      {routes.map((route) => {
        const teacher = route.teacher || {};
        const teacherAvatar = teacher.avatar || noAvatar;
        const teacherName =
          `${teacher.firstname || ""} ${teacher.lastname || ""}`.trim();

        return (
          <Card key={route._id} className="my-route-card">
            <Card.Content className="card-top">
              <Image
                src={teacherAvatar}
                alt="Teacher Avatar"
                size="tiny"
                circular
                centered
              />
            </Card.Content>
            <Card.Content>
              <Card.Header textAlign="center">{teacherName}</Card.Header>
              <Card.Meta textAlign="center">
                {t("portal.classLabel")}: {route.classnumber || "N/A"}
              </Card.Meta>
              <Card.Description textAlign="center">
                {route.nameRute}
              </Card.Description>
            </Card.Content>
            <Card.Content extra textAlign="center">
              <Button
                color="blue"
                onClick={() =>
                  onSelectRoute({
                    routeId: route._id,
                    classnumber: route.classnumber,
                    teacherId: teacher._id, // ← aquí pasamos el teacher
                  })
                }
              >
                {t("portal.enterButton")}
              </Button>
            </Card.Content>
          </Card>
        );
      })}
    </Card.Group>
  );
}
